module.exports = __webpack_public_path__ + "media/images/logotipo2-d31286fa64c70943b05a1e46aa229c66.png";